<div class="opt-dialog-container">
  <form [formGroup]="passwordForm" (ngSubmit)="change()">
    <h1 mat-dialog-title>Change Password</h1>
    <div mat-dialog-content>
      <mat-label>Password</mat-label>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          [type]="isPasswordHidden ? 'password' : 'text'"
          formControlName="password"
        />
        <button
          mat-icon-button
          matIconSuffix
          type="button"
          [class]="isPasswordHidden ? 'color-gray-24' : 'color-sidebar-bg'"
          (click)="isPasswordHidden = !isPasswordHidden"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="isPasswordHidden"
        >
          <mat-icon>{{
            isPasswordHidden ? 'visibility_off' : 'visibility'
          }}</mat-icon>
        </button>
      </mat-form-field>
      <div class="mat-form-field-rules">
        <mat-label
          [class]="
            password.hasError('required') || password.hasError('minlength')
              ? 'invalid'
              : 'valid'
          "
        >
          <mat-icon>
            {{
              password.hasError('required') || password.hasError('minlength')
                ? 'cancel'
                : 'check_circle'
            }}
          </mat-icon>
          Must be at least 8 characters
        </mat-label>
        <mat-label
          [class]="
            password.hasError('required') || password.hasError('hasNumber')
              ? 'invalid'
              : 'valid'
          "
        >
          <mat-icon>
            {{
              password.hasError('required') || password.hasError('hasNumber')
                ? 'cancel'
                : 'check_circle'
            }}
          </mat-icon>
          Must contain at least 1 number
        </mat-label>
        <mat-label
          [class]="
            password.hasError('required') || password.hasError('hasCapitalCase')
              ? 'invalid'
              : 'valid'
          "
        >
          <mat-icon>
            {{
              password.hasError('required') ||
              password.hasError('hasCapitalCase')
                ? 'cancel'
                : 'check_circle'
            }}
          </mat-icon>
          Must contain at least 1 letter in Capital Case
        </mat-label>
        <mat-label
          [class]="
            password.hasError('required') || password.hasError('hasSmallCase')
              ? 'invalid'
              : 'valid'
          "
        >
          <mat-icon>
            {{
              password.hasError('required') || password.hasError('hasSmallCase')
                ? 'cancel'
                : 'check_circle'
            }}
          </mat-icon>
          Must contain at least 1 letter in Small Case
        </mat-label>
      </div>
      <mat-label>Confirm Password</mat-label>
      <mat-form-field
        appearance="outline"
        [class.mat-form-field-invalid]="passwordForm.hasError('notEqual')"
        subscriptSizing="dynamic"
      >
        <input
          matInput
          [type]="isPasswordHidden ? 'password' : 'text'"
          formControlName="confirmation"
        />
        <button
          mat-icon-button
          matIconSuffix
          type="button"
          [class]="isPasswordHidden ? 'color-gray-24' : 'color-sidebar-bg'"
          (click)="isPasswordHidden = !isPasswordHidden"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="isPasswordHidden"
        >
          <mat-icon>{{
            isPasswordHidden ? 'visibility_off' : 'visibility'
          }}</mat-icon>
        </button>
      </mat-form-field>
      <ng-container
        *ngIf="
          confirmation.dirty ||
          confirmation.touched ||
          password.dirty ||
          password.touched
        "
      >
        <mat-error *ngIf="passwordForm.hasError('notEqual')">
          Password do not match
        </mat-error>
      </ng-container>
      <mat-label>Current password</mat-label>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          [type]="isCurrentPasswordHidden ? 'password' : 'text'"
          formControlName="current"
        />
        <button
          mat-icon-button
          matIconSuffix
          type="button"
          [class]="
            isCurrentPasswordHidden ? 'color-gray-24' : 'color-sidebar-bg'
          "
          (click)="isCurrentPasswordHidden = !isCurrentPasswordHidden"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="isCurrentPasswordHidden"
        >
          <mat-icon>{{
            isCurrentPasswordHidden ? 'visibility_off' : 'visibility'
          }}</mat-icon>
        </button>
      </mat-form-field>
      <mat-error
        *ngIf="
          current.hasError('required') && (current.dirty || current.touched)
        "
      >
        Please fill in the current password
      </mat-error>
      <div *ngIf="badResult">
        <mat-error *ngFor="let error of badResult.errors">
          {{ error }}
        </mat-error>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-flat-button type="button" (click)="cancel()">Cancel</button>

      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="passwordForm.disabled"
      >
        <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
        <span *ngIf="!isLoading">Save</span>
      </button>
    </div>
  </form>
</div>
